// extracted by mini-css-extract-plugin
export default {"h1":"GeneralInformationPage_h1__Kk0Lm","h3":"GeneralInformationPage_h3__gKeFq"};